module.exports = __webpack_public_path__ + "img/nowater_attached.42e5a0f0.svg";